<template>
  <div>
    <div :class="{
      'chat-messages-list-item-user': to === 'Bot',
      'chat-messages-list-item-other': to === 'User',
      'chat-messages-list-item-system': to === 'System'
    }" @mouseover="showReplyButton = true" @mouseleave="showReplyButton = false" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" :style="dragStyle">
      <div :class="{
        'chat-messages-list-item-user-message': to === 'Bot',
        'chat-messages-list-item-other-message': to === 'User',
        'chat-messages-list-item-system-message': to === 'System'
      }">
        <div v-if="reply" class="reply-container">
          <div :class="{
            'chat-messages-list-item-user': reply.to === 'Bot',
            'chat-messages-list-item-other': reply.to === 'User',
            'chat-messages-list-item-system': reply.to === 'System'
          }">
            <div :class="{
              'chat-messages-list-item-user-message': reply.to === 'Bot',
              'chat-messages-list-item-other-message': reply.to === 'User',
              'chat-messages-list-item-system-message': reply.to === 'System'
            }">
              <div v-if="reply.message.type.toLocaleLowerCase() === 'text'">
                <p v-html="formatChatMessage(reply.message)" />
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'image'  && reply.message.fileBase" class="chat-message-image-container">
                <img class="chat-message-image" :src="formatImageMessage(reply.message)" />
                <p v-html="formatChatMessageImage(reply.message)" />
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'ptt'  && reply.message.fileBase">
                <video controls="" name="media">
                  <source :src="formatAudioMessage(reply.message.fileBase)" type="audio/ogg">
                </video>
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'ptt' && !reply.message.fileBase">
                <div class="chat-message-document" @click="openAudioModal(message)">
                  <span class="chat-message-document-icon">
                    <i class="fas fa-play" />
                  </span>
                  <div class="chat-message-document-file">
                    <span class="chat-message-document-file-name">Audio</span>
                  </div>
                </div>
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'list'">
                <strong>
                  <p>{{ reply.message.title }}</p>
                </strong>
                <div v-for="(section, index) in reply.message.sections" :key="index">
                  <ul>
                    <li v-for="row in section.rows" :key="row.rowId">
                      {{ row.title }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'video'">
                <div class="chat-message-document">
                  <span class="chat-message-document-icon">
                    <i class="fas fa-play" />
                  </span>
                  <div class="chat-message-document-file">
                    <span class="chat-message-document-file-name">Video</span>
                  </div>
                </div>
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'document'">
                <div class="chat-message-document">
                  <span class="chat-message-document-icon">
                    <i class="fas fa-download" />
                  </span>
                  <div class="chat-message-document-file">
                    <span class="chat-message-document-file-name">Arquivo</span>
                  </div>
                </div>
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'image' && !reply.message.fileBase">
                <div class="chat-message-document" @click="getImage(message)">
                  <span class="chat-message-document-icon">
                    <i class="fas fa-image" />
                  </span>
                  <div class="chat-message-document-file">
                    <span class="chat-message-document-file-name">Imagem</span>
                  </div>
                </div>
              </div>
              <div v-else-if="reply.message.type.toLocaleLowerCase() === 'template'">
                <p>Esta é uma mensagem de template.</p>
              </div>
              <div class="message-status">
                {{ moment(reply.dateMessage).format('HH:mm') }}
                <span class="ml-1">
                  <i v-if="sent" class="fas fa-check" />
                  <i v-else class="fas fa-clock" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message.type.toLocaleLowerCase() === 'text'">
          <p v-html="formatChatMessage(message)" />
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'image' && message.fileBase" class="chat-message-image-container"
          @click="openImageModal(message.fileBase)">
          <img class="chat-message-image" :src="formatImageMessage(message)" />
          <div class="expand-indicator">
            <i class="fas fa-expand"></i>
          </div>
          <p v-html="formatChatMessageImage(message)" />
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'ptt' && message.fileBase">
          <div class="chat-message-document" @click="openAudioModal(message)">
            <span class="chat-message-document-icon">
              <i class="fas fa-play" />
            </span>
            <div class="chat-message-document-file">
              <span class="chat-message-document-file-name">Audio</span>
            </div>
          </div>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'ptt' && !message.fileBase">
          <div class="chat-message-document" @click="openAudioModal(message)">
            <span class="chat-message-document-icon">
              <i class="fas fa-play" />
            </span>
            <div class="chat-message-document-file">
              <span class="chat-message-document-file-name">Audio</span>
            </div>
          </div>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'list'">
          <strong>
            <p>{{ message.title }}</p>
          </strong>
          <div v-for="(section, index) in message.sections" :key="index">
            <ul>
              <li v-for="row in section.rows" :key="row.rowId">
                {{ row.title }}
              </li>
            </ul>
          </div>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'video'">
          <div class="chat-message-document" @click="openVideoModal(message)">
            <span class="chat-message-document-icon">
              <i class="fas fa-play" />
            </span>
            <div class="chat-message-document-file">
              <span class="chat-message-document-file-name">Video</span>
            </div>
          </div>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'image' && !message.fileBase">
          <div class="chat-message-document" @click="getImage(message)">
            <span class="chat-message-document-icon">
              <i class="fas fa-image" />
            </span>
            <div class="chat-message-document-file">
              <span class="chat-message-document-file-name">Imagem</span>
            </div>
          </div>
          <p v-html="formatChatMessageImage(message)" />
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'document'">
          <div class="chat-message-document" @click="handleDownloadFile(message)">
            <span class="chat-message-document-icon">
              <i class="fas fa-download" />
            </span>
            <div class="chat-message-document-file">
              <span class="chat-message-document-file-name">Arquivo</span>
            </div>
          </div>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'template'">
          <span class="chat-message-document-icon">
              <i class="fas fa-envelope-open"> Template</i>
            </span>
          <p>{{ message.template.name }}</p>
        </div>

        <div :class="{
          'chat-messages-list-item-user-message-notifications': to === 'Bot',
          'chat-messages-list-item-other-message-notifications': to === 'User',
          'chat-messages-list-item-system-message-notifications': to === 'System'
        } ">
          <div v-if="message.type.toLocaleLowerCase() === 'transferir'">
            <div class="chat-messages-actions">
              <p>Essa conversa foi transferida para {{ message.text }} <i v-if="description !== null"
                  class="fa fa-info-circle" :title="description"></i></p>
            </div>
          </div>
          <div v-else-if="message.type.toLocaleLowerCase() === 'assumir'">
            <div class="chat-messages-actions">
              <p>Essa conversa foi assumida por {{ message.text }} <i v-if="description !== null"
                  class="fa fa-info-circle" :title="description"></i></p>
            </div>
          </div>
          <div v-else-if="message.type.toLocaleLowerCase() === 'criar'">
            <div class="chat-messages-actions">
              <p>Essa conversa foi criada por {{ message.text }} <i v-if="description !== null" class="fa fa-info-circle"
                  :title="description"></i></p>
            </div>
          </div>
          <div class="message-status">
            {{ moment(date).format('HH:mm') }}
            <span class="ml-1">
              <i v-if="sent" class="fas fa-check" />
              <i v-else class="fas fa-clock" />
            </span>
          </div>
        </div>
      </div>
      <button class="reply-button"
        v-if="buttonReply && showReplyButton && !['transferir', 'assumir', 'criar'].includes(message.type)"
        @click="handleReply(message, to)"
        :class="{'reply-button-user': to === 'User', 'reply-button-bot': to === 'Bot'}">
        <i class="fas fa-reply"></i>
      </button>
    </div>
    <div v-if="isVideoModalOpen" class="image-modal" @click="closeVideoModal">
      <div class="image-modal-content" @click.stop>
        <video controls :src="currentVideoSrc" />
      </div>
      <div class="image-modal-footer">Fechar</div>
    </div>
    <div v-if="isImageModalOpen" class="image-modal" @click="closeImageModal">
      <div class="image-modal-content" @click.stop>
        <img :src="currentImageSrc" alt="Expanded Image" />
      </div>
      <div class="image-modal-footer">Fechar</div>
    </div>
    <div v-if="isAudioModalOpen" class="image-modal" @click="closeAudioModal">
      <div class="image-modal-content" @click.stop>
        <audio controls autoplay :src="currentAudioSrc" alt="Expanded Audio" />
      </div>
      <div class="image-modal-footer">Fechar</div>
    </div>
  </div>
</template>

<script>
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import {loading} from '@/shared/utils/UIHelper'

export default {
  name: 'ChatMessage',
  props: {
    to: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    message: {
      type: Object,
      required: false
    },
    date: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    sent: {
      type: Boolean,
      required: false,
      default: false
    },
    reply: {
      type: Object,
      required: false,
      default: null
    },
    provider: {
      type: String
    },
    identifierProvider: {
      type: String
    },
    buttonReply: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      isImageModalOpen: false,
      currentImageSrc: '',
      isVideoModalOpen: false,
      currentVideoSrc: '',
      isLoadingVideo: false,
      currentAudioSrc: '',
      isAudioModalOpen: false,
      showReplyButton: false,
      touchStartX: 0,
      touchEndX: 0,
      swipeThreshold: 50,
      dragStyle: {}
    }
  },
  methods: {
    formatChatMessage (message) {
      if (!message.text) {
        return ''
      }
      const urlRegex = /(https?:\/\/[^\s]+)/g
      return message.text
        .replaceAll('\n', '<br>')
        .replaceAll(/\*\*(.*?)\*\*/g, '<b>$1</b>')
        .replace(urlRegex, '<a href="$1" target="_blank" class="custom-link">$1</a>')
    },
    formatChatMessageImage (message) {
      if (!message.caption) {
        return ''
      }
      return message.caption.replaceAll('\n', '<br>').replaceAll(/\*\*(.*?)\*\*/g, '<b>$1</b>')
    },
    formatImageMessage (message) {
      if (message.fileBase) {
        const fileBase = message.fileBase.replace('data:image/jpeg;base64,', '')
        return `data:image/jpeg;base64,${fileBase}`
      }
    },
    formatAudioMessage (base64) {
      return `data:audio/ogg;base64,${base64}`
    },
    async handleDownloadFile (message) {
      let { fileBase, messageId, id } = message
      if (!fileBase) {
        try {
          let idArchive
          if (id) {
            idArchive = id
          } else {
            idArchive = messageId
          }
          const config = {
            idMessage: idArchive,
            provider: this.provider,
            identifierProvider: this.identifierProvider
          }
          const response = await AtendimentoRepository.GetArchive(config)
          fileBase = response.data.data
        } catch (error) {
          console.error('Error fetching file:', error)
          return
        }
      }

      const mimeType = fileBase.match(/^data:(.*?);base64,/)[1] || 'application/octet-stream'
      const base64Data = fileBase.replace(/^data:(.*?);base64,/, '')

      const blob = this.base64ToBlob(base64Data, mimeType)
      const extension = this.getExtensionFromMimeType(mimeType)
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `file.${extension}`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    base64ToBlob (base64, mimeType) {
      const byteString = window.atob(base64)
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const int8Array = new Uint8Array(arrayBuffer)

      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i)
      }

      return new Blob([int8Array], { type: mimeType })
    },
    getExtensionFromMimeType (mimeType) {
      const mimeTypes = {
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
        'application/vnd.oasis.opendocument.spreadsheet': 'ods',
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'audio/mpeg': 'mp3',
        'audio/ogg': 'ogg',
        'text/plain': 'txt',
        'application/zip': 'zip',
        'application/x-rar-compressed': 'rar'
      }

      return mimeTypes[mimeType] || 'bin'
    },
    async getImage (message) {
      let { messageId, id } = message

      loading.push()

      try {
        let idArchive
        if (id) {
          idArchive = id
        } else {
          idArchive = messageId
        }
        const config = {
          idMessage: idArchive,
          provider: this.provider,
          identifierProvider: this.identifierProvider
        }
        const response = await AtendimentoRepository.GetArchive(config)
        const image = response.data.data
        this.openImageModal(image)
      } catch (error) {
        console.error(error)
        loading.pop()
      } finally {
        loading.pop()
      }
    },
    openImageModal (fileBase) {
      console.log(fileBase)
      this.currentImageSrc = this.formatImageMessage({ fileBase })
      this.isImageModalOpen = true
    },
    async openVideoModal (message) {
      let { messageId, id } = message
      loading.push()
      try {
        let idArchive
        if (id) {
          idArchive = id
        } else {
          idArchive = messageId
        }

        const config = {
          idMessage: idArchive,
          provider: this.provider,
          identifierProvider: this.identifierProvider
        }
        const response = await AtendimentoRepository.GetArchive(config)
        const base64 = response.data.data
        this.currentVideoSrc = base64
      } catch (error) {
        console.error(error)
        loading.pop()
      } finally {
        loading.pop()
        this.isVideoModalOpen = true
      }
    },
    async openAudioModal (message) {
      const {id, messageId} = message
      loading.push()
      try {
        let idArchive
        if (id) {
          idArchive = id
        } else {
          idArchive = messageId
        }

        const config = {
          idMessage: idArchive,
          provider: this.provider,
          identifierProvider: this.identifierProvider
        }
        const response = await AtendimentoRepository.GetArchive(config)
        const base64 = response.data.data
        this.currentAudioSrc = base64
      } catch (error) {
        console.error(error)
        loading.pop()
      } finally {
        loading.pop()
        this.isAudioModalOpen = true
      }
    },
    closeImageModal () {
      this.isImageModalOpen = false
    },
    closeAudioModal () {
      this.isAudioModalOpen = false
    },
    closeVideoModal () {
      this.isVideoModalOpen = false
    },
    truncateMessage (text, maxLength) {
      if (text.length <= maxLength) {
        return text
      }
      return text.substring(0, maxLength) + '...'
    },

    handleReply (message, to) {
      this.$emit('reply', { message, to })
    },
    handleTouchStart (event) {
      this.touchStartX = event.changedTouches[0].screenX
      this.dragStyle = { transition: 'none' }
    },
    handleTouchMove (event) {
      this.touchEndX = event.changedTouches[0].screenX
      const dragDistance = this.touchEndX - this.touchStartX
      if (this.to === 'Bot') {
        if (dragDistance < 0) {
          this.dragStyle = { transform: `translateX(${dragDistance}px)` }
        }
        if (dragDistance < -this.swipeThreshold) {
          this.dragStyle = { transform: `translateX(${-this.swipeThreshold}px)` }
        }
      } else {
        if (dragDistance > 0) {
          this.dragStyle = { transform: `translateX(${dragDistance}px)` }
        }
        if (dragDistance > this.swipeThreshold) {
          this.dragStyle = { transform: `translateX(${this.swipeThreshold}px)` }
        }
      }
    },
    handleTouchEnd () {
      const dragDistance = this.touchEndX - this.touchStartX
      if (this.to === 'Bot' && dragDistance < -this.swipeThreshold) {
        this.handleReply(this.message, this.to)
      } else if (this.to !== 'Bot' && dragDistance > this.swipeThreshold) {
        this.handleReply(this.message, this.to)
      }
      this.dragStyle = { transform: 'translateX(0)', transition: 'transform 0.3s ease' }
    }
  }
}
</script>

<style scoped>
.reply-container {
  border-left: 4px solid #34b7f1;
  margin-bottom: 10px;
  background-color: #f0f0f0;
  border-radius: 0;
  padding: 10px;
}

.reply-content {
  font-size: 14px;
  color: #555;
}

.reply-content strong {
  color: #000;
}

.reply-time {
  font-size: 12px;
  color: #888;
  text-align: right;
  margin-top: 5px;
}

.chat-message-image-container {
  position: relative;
  display: inline-block;
}

.chat-message-image {
  width: 200px;
  height: auto;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.chat-message-image-container:hover .chat-message-image {
  opacity: 0.8;
}

.chat-messages-list-item-other-message {
  color: black;
}

.expand-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px;
  border-radius: 50%;
  font-size: 24px;
  display: none;
  justify-content: center;
  align-items: center;
}

.chat-message-image-container:hover .expand-indicator {
  display: flex;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: auto;
}

.image-modal-content {
  position: relative;
  max-width: 70vw;
  max-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-modal-content img {
  max-width: 75vw;
  max-height: 75vh;
  object-fit: contain;
}

.image-modal-footer {
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  background: rgba(0, 0, 0, 0.6);
  padding: 5px;
  border-radius: 5px;
  font-size: 14px;
}

.custom-link {
  color: #55d4ff;
  text-decoration: none;
}

.custom-link:hover {
  text-decoration: underline;
}
.reply-menu-container {
  position: relative;
  display: inline-block;
}

.reply-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #1a9484b8;
  font-size: 20px;
}

.reply-button:hover {
  color: #035f53b8;
}

.reply-button-user i {
  transform: rotate(180deg);
}

.reply-button-bot i {
  transform: rotate(0deg);
}

</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/ChatMessage.vue